import React from 'react';
import { FormGroup } from "react-bootstrap";

const FieldGroup = ( obj ) => {
    const { id, name, label, help, error, register, refObject, message } = obj;
    return (
        <FormGroup controlId={ id }>
            <label>{ label }</label>
            { refObject !== undefined ?
                message ?
                    <><input name={ name } ref={ register( refObject ) }/> { error &&
                    <span className={ "helpBlock" }>{ message }</span> }</>
                    :
                    <><input name={ name } ref={ register( refObject ) }/> { error && <span
                        className={ error.message.length > 50 ? "helpBlock help-block-large" : "helpBlock" }>{ error.message }</span> }</>
                :
                <><input name={ name } ref={ register( { required: help } ) }/>{ error &&
                <span className={ "helpBlock" }>{ help }</span> } </> }
        </FormGroup>
    );
}

export default FieldGroup;
